/* eslint-disable no-unused-vars */
import { createAction, createSlice, Middleware } from "@reduxjs/toolkit";

type TProps = {
  currentTree: string | null;
  currentObj: Array<string>;
  nodeLabel: string | null;
  devicePage: boolean;
  balancePage: boolean;
  reportPage: boolean;
  exportPage: boolean;
  plannerPage: boolean;
  operatorPage: boolean;
  configPage: boolean;
  graphPage: boolean;
};

const getInitialState = (): TProps => {
  const savedState = localStorage.getItem("propsState");
  if (savedState) {
    const parsedState = JSON.parse(savedState);

    return {
      ...parsedState,
      currentTree: null,
      currentObj: [],
      nodeLabel: null,
    };
  }

  return {
    currentTree: null,
    currentObj: [],
    nodeLabel: null,
    devicePage: true,
    balancePage: true,
    reportPage: true,
    exportPage: true,
    plannerPage: true,
    operatorPage: true,
    configPage: true,
    graphPage: false,
  };
};

const initialState: TProps = getInitialState();

export const setCurrentProps = createAction<TProps>("props/current");
export type TShowPMAction = {
  page: string;
};
export const setShowPM = createAction<TShowPMAction>("props/show");

const propsSlice = createSlice({
  name: "props",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setCurrentProps, (state, { payload }) => {
        state.currentTree = payload.currentTree;
        state.currentObj = payload.currentObj;
        state.nodeLabel = payload.nodeLabel;
      })
      .addCase(setShowPM, (state, { payload }) => {
        switch (payload.page) {
          case "device": {
            state.devicePage = !state.devicePage;
            break;
          }
          case "balance": {
            state.balancePage = !state.balancePage;
            break;
          }
          case "report": {
            state.reportPage = !state.reportPage;
            break;
          }
          case "export": {
            state.exportPage = !state.exportPage;
            break;
          }
          case "planner": {
            state.plannerPage = !state.plannerPage;
            break;
          }
          case "operator": {
            state.operatorPage = !state.operatorPage;
            break;
          }
          case "graph": {
            state.graphPage = !state.graphPage;
            break;
          }
        }
      });
  },
});

const filterStateForLocalStorage = (state: TProps) => {
  const { currentTree, currentObj, nodeLabel, ...filteredState } = state;

  return filteredState;
};

export const saveStateMiddleware: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);
    const state = store.getState().props;
    const filteredState = filterStateForLocalStorage(state);
    localStorage.setItem("propsState", JSON.stringify(filteredState));

    return result;
  };

export default propsSlice.reducer;
